import { Settings, WidgetData } from "./data"
import { Widget } from "./widget"

export type AccordionData = WidgetData & {
  settings: Settings & {
    tabs: Array<{ tab_title: string, tab_content: string, }>,
  }
  widgetType: "accordion"
}

export type AccordionWidgetItem = {
  title: string,
  content: string,
}

export class AccordionWidget extends Widget {
  items: Array<AccordionWidgetItem>

  constructor(data: AccordionData) {
    super(data);

    this.items = data.settings.tabs.map(
      el => ({ title: el.tab_title, content: el.tab_content })
    );
  }
}
